<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [scrollY]="true">
  <div>
    <div class="project-image">
      <img [src]="image" alt="Project image" />
    </div>

    <h3 class="ds-title-3">{{ title }}</h3>

    <h4>{{ 'IMPACT.tabName' | translate }}</h4>

    <div [innerHTML]="impactDescription" class="description"></div>
  </div>
</ion-content>
